'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msSleepMinuteSelector', {
    templateUrl: 'sleep/templates/sleep-minute-selector.html',
    controller: SleepMinuteSelector,
    controllerAs: 'vm',
    bindings: {
      /* <boolean> to indicate if dropdowns should be disabled */
      isDisabled: '<',
      selectedValue: '='
    }
  });
  SleepMinuteSelector.$inject = ['$scope', '$rootScope'];

  function SleepMinuteSelector($scope, $rootScope) {
    var vm = this;
    vm.componentId = $scope.$id;
    // Slowly increase the jumps from 5 minutes at the begining to 30 at the end
    vm.possibleMinutes = [].concat(_.range(0, 15, 5), _.range(15, 120, 15), _.range(120, 481, 30));

    vm.setOpenSelectState = function () {
      $rootScope.isSelectOpened = true;
    };

    vm.removeOpenSelectState = function () {
      delete $rootScope.isSelectOpened;
    };
  }
})();